import { Component, OnInit, AfterViewInit, Input, ElementRef, ViewChild, Injector } from "@angular/core";
import { NgbActiveModal, NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AppComponentBase } from "../../../services/AppComponentBase";
import { FormGroup, FormControl, FormBuilder, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import * as jQuery from "jquery";
import { DataService } from "../../../services/data/data.service";
import { Workspace } from "../../../model/workspace.data";
import { IDemoUser } from "../../../interfaces/IDemoUsers";
import { CreateAccountRequest } from "../../../model/create-account.request.data";
import { AgGridModule } from "ag-grid-angular";
import { GridOptions, GridApi, ColumnApi, ColDef } from "ag-grid";
import { AgGridNg2 } from "ag-grid-angular";
import { strategyCellRendererComponent } from "../../../renderers/strategyCellRendererComponent.component";
import { GlobalGridModeService } from "../../../services/globalGridMode/globalGridMode.service";
import { callNextAsync } from "../../../services/BaseService";
import { currencyRenderer } from "../../../renderers/currencyFormatters.component";
import { ShowEditUserModal, ShowAddDeleteUserModal, ShowAddNewPUserSetModal } from "./show-demo-users-modal";

@Component({
    selector: "modal-demoUsers",
    template: require('./demoUsers.component.html'),
    styles: [require('../SavedStrategiesModal/SavedStrategiesModal.component.css')]
})
export class demoUsersModal extends AppComponentBase {
    constructor(
        injector: Injector,
        public activeModal: NgbActiveModal,
        protected ngbModalService: NgbModal,
        protected globalGridModeService: GlobalGridModeService
    ) {
        super(injector);

        /*********GRID */

        this.gridOptions = <GridOptions>{};
        this.gridOptions.defaultColDef = {
            cellClass: "orders-cell"
            // width:150,
        };

        this.gridOptions.enableFilter = true;
        this.rowSelection = "single";

        this.refreshUserList();

        this.globalGridModeService.UserListUpdate.subscribe(v => {
            this.refreshUserList();
        });

        // this.globalGridModeService.sendModelNewUserSet.subscribe(v => {
        //     console.log("sendModelNewUserSet");

        // //    this.seletedRowParameterSetId = "";
        // });

        /***************GRID* */
    }

    public refreshUserList() {
        this.workspace
            .loadAccounts(this.workspace.userName)
            .then(response => {
                //console.log(response);

                if (response !== null) {
                    this.workspace.accounts = response;
                    console.log(response);
                    this.refreshGridData();
                }
            })
            .catch(error => {
                console.error(error);
            });
    }

    private _modalSubType: string = "standard";
    public get modalSubType(): string {
        return this._modalSubType;
    }
    public set modalSubType(value: string) {
        this._modalSubType = value;
    }

    /*****************************GRID */

    private _seletedRowParameterSetId: string = "";
    public get seletedRowParameterSetId(): string {
        return this._seletedRowParameterSetId;
    }
    public set seletedRowParameterSetId(value: string) {
        this._seletedRowParameterSetId = value;
    }

    columnDefs = [
        {
            headerName: "Name",
            field: "accountName",
            width: 125,
            filter: "agTextColumnFilter",
            cellStyle: { "text-align": "left" }
        },
        {
            headerName: "Balance",
            field: "balance",
            cellRendererFramework: currencyRenderer,
            width: 125,
            filter: "agTextColumnFilter",
            cellStyle: { "text-align": "left" }
        },
        {
            headerName: " ",
            width: 60,
            cellStyle: { "text-align": "left", "padding-left": "5px !important;" },
            cellRendererFramework: strategyCellRendererComponent,
            cellRendererParams: {
                edit: this.editAction.bind(this),
                delete: this.deleteAction.bind(this),
                modalService: this.ngbModalService,
                workspaceService: this.workspaceService,
                accountsMode: true
            }
        }
    ];

    public gridOptions: GridOptions;
    public rowSelection: any;
    protected gridApi: any;
    protected gridColumnApi: any;

    editAction(params: any) {
        ShowEditUserModal(this.modalService, params.data.id, this.workspace.mobileMode);
    }

    deleteAction(params: any) {
        console.log(params.data);
        ShowAddDeleteUserModal(this.modalService, params.data.id, this.workspace.mobileMode);
    }

    getRowNodeId(data: any) {
        return data.id;
    }

    public onGridReady(params: GridOptions) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        if (this.gridApi) this.gridApi.setRowData([]);

        this.refreshGridData();
    }

    refreshGridData() {
        if (this.gridApi) {
            this.gridApi.setRowData([]);

            this.gridApi.updateRowData({ add: this.usersList });

            this.gridApi.clearFocusedCell();
        }
    }

    public onSelectionChanged(e: any) {
        if (this.gridApi !== undefined) {
            let row = this.gridApi.getDisplayedRowAtIndex(e.rowIndex);

            if (row !== undefined) this.seletedRowParameterSetId = row.data.id;
        }
    }

    /*****************END GRID**************** */

    get usersList() {
        return this.workspace.accounts;
    }

    get activeAccountId() {
        return this.workspace.activeAccountId;
    }

    get accountToDelete() {
        return this.usersList.find(a => a.id == this.idToDelete);
    }

    private _showDeleteScreen: boolean = false;
    public get showDeleteScreen(): boolean {
        return this._showDeleteScreen;
    }
    public set showDeleteScreen(value: boolean) {
        this._showDeleteScreen = value;
    }

    public filteredUsersList: IDemoUser[] = [];

    removeDemoUser(id: number) {
        //this.usersList.splice(this.usersList.findIndex(item => item.Id === id), 1);
        this.idToDelete = id;
        //this.filteredUsersList = this.usersList.filter( c=>{ if(c.Id==id)return c} )
        this.showDeleteScreen = true;
    }

    public idToDelete: number = 0;
    removeDemoUserAction() {
        this.deleteAccount(this.idToDelete)
            .then(response => {
                //console.log(response);

                if (response !== null) {
                    //  this.refreshUserList();
                    this.globalGridModeService.UserListUpdate.next(response);
                    this.closeWindow();
                }
            })
            .catch(error => {
                console.error(error);
            });
    }

    public deleteAccount(accountId: number): Promise<number> {
        return new Promise<number>((rs, rj) => {
            this.workspace.AccountsClient.deleteAccountByAccountId(accountId)
                .toPromise()
                .then(s => {
                    rs(s);
                })
                .catch(error => {
                    console.error(error);
                    rj(error);
                });
        });
    }

    public addAccount(userId: number, accountName: string, equityValue: number): Promise<number> {
        return new Promise<number>((rs, rj) => {
            this.workspace.AccountsClient.addNewAccountForExistedUser(userId, accountName, equityValue)
                .toPromise()
                .then(s => {
                    rs(s);
                })
                .catch(error => {
                    console.error(error);
                    rj(error);
                });
        });
    }

    public renameAccount(accountId: number, accountName: string): Promise<number> {
        return new Promise<number>((rs, rj) => {
            this.workspace.AccountsClient.editAccountForExistedUser(accountId, accountName)
                .toPromise()
                .then(s => {
                    rs(s);
                })
                .catch(error => {
                    console.error(error);
                    rj(error);
                });
        });
    }

    addNewDemoAccount() {
        this.addAccount(this.workspace.userId, this.demoName, this.equityValue)
            .then(response => {
                if (response !== null) {
                    this.globalGridModeService.UserListUpdate.next(response);
                    this.closeWindow();
                }
            })
            .catch(error => {
                console.error(error);
            });
    }

    editAccount() {
        this.renameAccount(this.idToEdit, this.editName)
            .then(response => {
                if (response !== null) {
                    this.globalGridModeService.UserListUpdate.next(response);
                    this.closeWindow();
                }
            })
            .catch(error => {
                console.error(error);
            });
    }

    closeWindow() {
        this.activeModal.close();
    }

    private _showAddNew: boolean = false;
    public get showAddNew(): boolean {
        return this._showAddNew;
    }
    public set showAddNew(value: boolean) {
        this._showAddNew = value;
    }

    public editName: string = "";
    private _idToEdit = 0;
    public get idToEdit() {
        return this._idToEdit;
    }
    public set idToEdit(value: number) {
        this._idToEdit = value;
        if (value == 0) {
            if (this.dissmissAfterEdit) this.activeModal.dismiss();
            return;
        }
        const account = this.usersList.find(a => a.id == value);
        if (account == null) return;
        this.editName = String(account.accountName);
    }

    dissmissAfterEdit = false;

    private _demoName: string = "";
    public get demoName(): string {
        return this._demoName;
    }
    public set demoName(value: string) {
        this._demoName = value;
    }

    private _equityValue: number = 1000;
    public get equityValue(): number {
        return this._equityValue;
    }
    public set equityValue(value: number) {
        this._equityValue = value;
    }

    public addNewDemoAccountModal() {
        ShowAddNewPUserSetModal(this.ngbModalService, this.workspace.mobileMode);
    }

    private _currentRequestId: string = "";

    sendChangeRequest(): void {
        // this.dataService.sendRequest(orderChangeData);
    }
}
